import { FORM_FIELD_LIMITS } from '../constants/form-field-limits';

/** E-mail “suficientemente” válido para o cliente (o servidor valida de forma definitiva). */
export function isValidEmailFormat(email: string): boolean {
  const t = email.trim();
  if (!t || t.length > FORM_FIELD_LIMITS.email) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t);
}

export function exceedsMaxLength(value: string, max: number): boolean {
  return value.length > max;
}

/** Garante que `value` não excede `max` (útil após colar texto). */
export function clampToMaxLength(value: string, max: number): string {
  if (value.length <= max) return value;
  return value.slice(0, max);
}
